import React, { useState } from 'react';
import { testApiConnection, testLogin, testOpenApiDocs } from '@/utils/networkTest';

/**
 * Development component to test API connectivity and authentication
 * Located in /dev folder to indicate it's for development/debugging only
 */
export const AuthTest: React.FC = () => {
  const [testResults, setTestResults] = useState<string>('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleTestConnection = async () => {
    setTestResults('Testing API connection...');
    const result = await testApiConnection();
    console.log('Connection test result:', result);
    setTestResults(JSON.stringify(result, null, 2));
  };

  const handleTestOpenApi = async () => {
    setTestResults('Testing OpenAPI docs...');
    const result = await testOpenApiDocs();
    console.log('OpenAPI test result:', result);
    setTestResults(JSON.stringify(result, null, 2));
  };

  const handleTestLogin = async () => {
    if (!email || !password) {
      setTestResults('Please enter email and password');
      return;
    }
    
    setTestResults('Testing login...');
    console.log('Testing login with:', { email, password: '***' });
    const result = await testLogin(email, password);
    console.log('Login test result:', result);
    setTestResults(JSON.stringify(result, null, 2));
  };

  const runAllTests = async () => {
    setTestResults('Running all tests...\n\n');
    
    // Test 1: OpenAPI docs
    const openApiResult = await testOpenApiDocs();
    setTestResults(prev => prev + '1. OpenAPI Docs Test:\n' + JSON.stringify(openApiResult, null, 2) + '\n\n');
    
    // Test 2: API connection
    const connectionResult = await testApiConnection();
    setTestResults(prev => prev + '2. API Connection Test:\n' + JSON.stringify(connectionResult, null, 2) + '\n\n');
    
    // Test 3: Login (if credentials provided)
    if (email && password) {
      const loginResult = await testLogin(email, password);
      setTestResults(prev => prev + '3. Login Test:\n' + JSON.stringify(loginResult, null, 2) + '\n\n');
    } else {
      setTestResults(prev => prev + '3. Login Test: Skipped (no credentials provided)\n\n');
    }
  };

  return (
    <div style={{ padding: '20px', border: '2px solid #007acc', margin: '20px', borderRadius: '8px' }}>
      <h3 style={{ color: '#007acc', marginTop: 0 }}>🔧 Development API Test Suite</h3>
      
      <div style={{ marginBottom: '15px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <button onClick={handleTestOpenApi} style={{ padding: '8px 12px' }}>
          Test OpenAPI Docs
        </button>
        <button onClick={handleTestConnection} style={{ padding: '8px 12px' }}>
          Test API Connection
        </button>
        <button onClick={runAllTests} style={{ padding: '8px 12px', backgroundColor: '#007acc', color: 'white', border: 'none', borderRadius: '4px' }}>
          Run All Tests
        </button>
      </div>
      
      <div style={{ marginBottom: '15px', display: 'flex', gap: '10px', alignItems: 'center' }}>
        <input
          type="email"
          placeholder="Email for login test"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', flex: 1 }}
        />
        <input
          type="password"
          placeholder="Password for login test"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', flex: 1 }}
        />
        <button onClick={handleTestLogin} style={{ padding: '8px 12px' }}>
          Test Login
        </button>
      </div>
      
      <pre style={{ 
        background: '#f8f9fa', 
        padding: '15px', 
        whiteSpace: 'pre-wrap',
        maxHeight: '400px',
        overflow: 'auto',
        border: '1px solid #e9ecef',
        borderRadius: '4px',
        fontSize: '12px',
        lineHeight: '1.4'
      }}>
        {testResults || 'No tests run yet. Click "Run All Tests" to start debugging.'}
      </pre>
    </div>
  );
};